import { Component, OnInit } from '@angular/core';
import {Ticket} from "../ticket";
import {BooKingservice} from "../booking.service";
import {Order} from "../order";
import {Pricing} from "../pricing";
import {Router} from "@angular/router";
import {AuthService} from "../../../core/auth/auth.service";
import {BookingList} from "../../event/bookingList";
import {TranslateService} from "@ngx-translate/core";
import {FonctionUtiles} from "../../fonctionsUtiles";
import {FoEventsService} from "../../event/foevents.service";
import {Subscription} from "rxjs";


@Component({
  selector: 'app-booking-infos',
  templateUrl: './booking-infos.component.html',
  styleUrls: ['./booking-infos.component.css'],
  providers :[BooKingservice,AuthService]
})
export class BookingInfosComponent implements OnInit {
  order: Order;
  subscription: Subscription;
  label: any;
  price: any;
  tickets: Ticket[] = [];
  sendToFriends: boolean = false;
  bookingLists: BookingList[] = [];
  pricings: Pricing[];
  Total: any;
  event: any;
  dayname: string;
  hours: number;
  day: number;
  month: string;
  billet:boolean = true;
  condition:boolean = false;
  organiserCondition: boolean = false;
  donation_receipt: boolean = false;
  nbreTicket: number;
  // ui
  recapIsOpen: boolean = true;
  formIsOpen: boolean = true;
  devise: any;
  daysarray:any = [];
  monthsarray:any = [];
  front_booking_infos: any;
  expirationTime: number;
  currenteventUrl: any;
  d: any;
  locationCountryCode: any;
  countries: any;
  country;
  insCriptionMode:boolean = false;
  isSignup: boolean = false;
  isSignin: boolean = true;
  showBukinInput: boolean = false;
  fee: number = 0;
  codePromosActivated: any = [];
  embeded = false;
  allCodePromoActivated: any = [];


  constructor(
    private bookingservice:BooKingservice,
    private router:Router,
    private authservice :AuthService,
    private eventservice: FoEventsService,
    private translateService:TranslateService,
    public functionUtils:FonctionUtiles,
    private eventService:FoEventsService) {
    this.bookingservice.clearAndInitBookingItemInStorage();
    this.authservice.setDestination('/booking/infos');
    this.expirationTime = this.bookingservice.retrieve('sessionExpirationTime');
    this.currenteventUrl =  this.bookingservice.retrieve('currenteventUrl');
    this.retriveDataFromStorage();
    if(this.bookingservice.retrieve('embeded')) {
      console.log('ok embeded');
      this.embeded = this.bookingservice.retrieve('embeded');
    }
  }

  showPrice(price) {
    return price === 0 ?' Gratuit' :' '+ price;
  }
  showCurrency(currency,price) {
    return price === 0 ?' ': currency;
  }

  setDevises(event) {
    if(event.currency) {
      this.devise = event.currency
    }
    else {
      this.devise = 'Eur'
    }
  }

  calculateptionsfee(optionTotal){
    return this.functionUtils.calculOptionsFee(optionTotal,this.devise);
  }

  loggedIn() {
    return this.authservice.hasValidToken();
  }

  calculatePricingPriceAfterPromoApply(pricing) {
    if(pricing.codePromo && pricing.codePromo.reduction_simple)
      return this.getPricingPrice(pricing)  - pricing.codePromo.reduction_simple;
    else if(pricing.codePromo && pricing.codePromo.reduction_by_percentage )
      return this.getPricingPrice(pricing)  - (this.getPricingPrice(pricing)* pricing.codePromo.reduction_by_percentage/100);

  }

  /*calculTotal (pricings)
   {
    this.Total=0;
    this.nbreTicket=0;
    for (let i=0; i<pricings.length; i++) {
        if(pricings[i].price && pricings[i].nbreTicket)
         /!* if(pricings[i].codePromo)
          {
            if (!pricings[i].open)
              this.Total += pricings[i].nbreTicket * this.getPricingPrice(pricings[i]) - this.functionUtils.CodePRomoReduction(pricings[i],this.event);
            else
              this.Total +=   this.getPricingPrice(pricings[i]) - this.functionUtils.CodePRomoReduction(pricings[i],this.event);
          }
          else*!/

          if (!pricings[i].open)
            this.Total += pricings[i].nbreTicket * this.getPricingPrice(pricings[i]) - this.functionUtils.CodePRomoReduction(pricings[i],this.event);
          else
            this.Total += this.getPricingPrice(pricings[i]) - this.functionUtils.CodePRomoReduction(pricings[i],this.event);


           this.nbreTicket += pricings[i].nbreTicket;
       }
        return this.Total.toFixed(2) +' '+this.functionUtils.getPricingDeviseSymbole(this.devise)
   }*/


  getPricingPrice(pricing) {
    return this.functionUtils.getPricingPrice(pricing);
  }

  calculateOptionTotal() {
    return this.functionUtils.calculateOptionTotal(this.order);
  }

  ngOnInit() {
    this.setDevises(this.event);
    this.loadTranslation();
    this.fillBuyerinputs();
    this.loadCountries();
    this.scrollToTop();
    this.initDataWhenOpenTicketing();
    this.initTicketsDatawhenNotOpenTicketing();
    this.fee = this.functionUtils.globalFee(this.functionUtils.calculFrais1(this.pricings, this.devise),this.calculTotal(this.pricings,this.codePromosActivated));
  }

  scrollToTop() {
    this.functionUtils.displayMessages();
  }
  showSigup() {
    this.isSignin = false;
    this.isSignup = true;
  }

  showSignIn() {
    this.isSignup = false;
    this.isSignin = true;
  }
  recieveLoggenIn() {
    let that = this;
    setTimeout(function(){
     if(!that.getUserCloe()){
       window.location.reload()
     }
      that.fillBuyerinputs();
      that.initDataWhenOpenTicketing();
      that.initTicketsDatawhenNotOpenTicketing();
    }, 3000);
  }

  loadIP() {
    this.loadIp().then(res=> {
      if(res)
        this.locationCountryCode = res.countryCode.toLowerCase();
      else
        this.locationCountryCode = 'tg';

    });
  }

  findCountryByName(countries) {
    for(let i = 0 ; i < countries.length; i++) {
      if(countries[i].translations.fr == this.event.country) {
        return countries[i];
      }
    }
  }

  loadCountries() {
    this.eventService.pays().then(any => {
      if(this.findCountryByName(any) && this.findCountryByName(any).alpha2Code)
        if(this.event.id != 234)
            this.locationCountryCode = this.findCountryByName(any).alpha2Code.toLowerCase();
        else
            this.locationCountryCode ='fr';
      else
        this.locationCountryCode = 'gp';
      }
    )
  }

  loadIp() {
    return this.eventService.getIp();
  }

  retriveDataFromStorage() {
    this.event = this.bookingservice.retrieve('event');
    this.order  = this.bookingservice.retrieve('order');
    this.bookingLists = this.bookingservice.retrieve('bookingList');
    this.pricings = this.bookingservice.retrieve('pricings');
    this.insCriptionMode = this.bookingservice.retrieve('inscriptionIframe');
    this.codePromosActivated = this.bookingservice.retrieve('codePromosActivated');
    console.log(this.bookingservice.retrieve('codePromosActivated'));
  }


  loadTranslation() {
    this.translateService.get('front_booking_infos').subscribe(
      value => {
        let debut=(this.event.start_date+'T'+this.event.start_hour);
        this.d = new Date(debut);
        this.dayname = value.daysarray.split(',')[this.d.getDay()];
        this.month = value.months.split(',')[this.d.getMonth()];
        this.front_booking_infos = value;
        this.hours = this.d.getHours();
        this.day = this.d.getDate();
      }
    );
  }

  inputIsNotEditable(input){
    return input.label == 'Nom' || input.label == 'Prénom' || input.label == 'Email';
  }
  total() {
    return parseFloat(this.calculTotal(this.pricings,this.codePromosActivated)) + this.fee;
  }

  displayTotal(total) {
     if(total == 0) {
        return 'Gratuit'
     }
     else {
          return  parseFloat(total).toFixed(2)+' '+this.functionUtils.getPricingDeviseSymbole(this.devise);
     }
  }

  copyStr(original_string){
   return (' ' + original_string).slice(1)
  }

  getUserCloe(){
   /* const curentUser = {...this.authservice.getUser()};*/
    //return  Object.assign({}, JSON.parse( JSON.stringify(this.authservice.getUser())));
    return this.authservice.getUser();
  }

  fillBuyerinputs() {
    if(this.authservice.getUser()) {

      if (this.findInput(this.order.Buyerinputs,'Nom')) {
        this.findInput(this.order.Buyerinputs,'Nom').value = this.getUserCloe().firstname;
        this.findInput(this.order.Buyerinputs,'Nom').isValid = true;
      }

      if (this.findInput(this.order.Buyerinputs,'Email')) {
        this.findInput(this.order.Buyerinputs,'Email').value = this.getUserCloe().email;
        this.findInput(this.order.Buyerinputs,'Email').isValid = true;
      }

      if (this.findInput(this.order.Buyerinputs,'Prénom')) {
        this.findInput(this.order.Buyerinputs,'Prénom').value = this.getUserCloe().lastname;
        this.findInput(this.order.Buyerinputs,'Prénom').isValid = true;
      }
    }
  }



  participantName(ticket) {
    if(this.findInput(ticket.form.inputsTicket,'Nom') && this.findInput(ticket.form.inputsTicket,'Prénom')) {
      return this.findInput(ticket.form.inputsTicket,'Nom').value+' '+ this.findInput(ticket.form.inputsTicket,'Prénom').value;
    }
  }


  toggleSendToFriends() {
    this.sendToFriends = !this.sendToFriends;
  }

  inputPlaceholder() {
    if(this.event.has_open_ticketing)
      return this.front_booking_infos.participant;
    else
      return this.front_booking_infos.carrier;
  }

  toggleRecap() {
    this.recapIsOpen = !this.recapIsOpen;
  }

  toggleForm() {
    this.formIsOpen = !this.formIsOpen;
  }

  check($event) {
   /* console.log(this.tickets)*/
  }


  receiveLoggedInMessage($event) {
   /* console.log($event);*/
    console.log('logged in on Booking')
    this.fillBuyerinputs();
    this.initDataWhenOpenTicketing();
    this.initTicketsDatawhenNotOpenTicketing();
  }

  showLoginAndSignup() {
    return !this.loggedIn() || this.getUserCloe() && this.getUserCloe().isPreAccount && !this.showBukinInput;
  }

  shoWBookingInputs() {
    return this.loggedIn() && this.formIsOpen && (this.getUserCloe() && !this.getUserCloe().isPreAccount) && this.getUserCloe().email || this.showBukinInput;
  }

  checkcondition($event) {
    this.condition =! this.condition;
  }

  checkOrganizerCondition($event) {
    this.organiserCondition =! this.organiserCondition;
  }

  checkdonationReceipt($event) {
    this.donation_receipt =! this.donation_receipt;
    this.order.donation_receipt = !this.order.donation_receipt;
  }

  showCgu(){
    let $ = window['jQuery'];
    $('#organizeCgu').modal('show');
  }

  organame(){
    return
  }

  findInput(arr,string1) {
    for ( let i = 0 ; i < arr.length; i++) {
      if(arr[i].label == string1)
         return arr[i];
    }
    return false;
  }

  bookingGotMoreThanOneTicket(bookingLists) {
    if(this.bookingLists.length > 1)
       return true;
    for(let i = 0 ; i < bookingLists.length; i++) {
      if(bookingLists[i].tickets.length > 1 )
        return true;
    }
    return false;
  }

  ShowParticipantsData(bookingLists) {
    for(let i = 0 ; i < bookingLists.length; i++) {
      if(bookingLists[i].tickets.length > 0 )
        return true;
    }
    return false;
  }


  //is used to show that all inputs of a specific participants are valid
  showCheckParticipants(ticket) {
    if(ticket.form && ticket.form.inputsTicket)
    for(let i=0;i< ticket.form.inputsTicket.length;i++) {
      if(!ticket.form.inputsTicket[i].isValid )
        return false;
    }
    return true;
  }

  initTicketsDatawhenNotOpenTicketing() {
    if(this.authservice.getUser()) {
      if (!this.event.has_open_ticketing) {

        if (this.findInput(this.bookingLists[0].tickets[0].form.inputsTicket, 'Nom')) {
          this.findInput(this.bookingLists[0].tickets[0].form.inputsTicket, 'Nom').value = this.getUserCloe().firstname;
          this.findInput(this.bookingLists[0].tickets[0].form.inputsTicket, 'Nom').isValid = true;
        }

        if (this.findInput(this.bookingLists[0].tickets[0].form.inputsTicket, 'Email')) {
          this.findInput(this.bookingLists[0].tickets[0].form.inputsTicket, 'Email').value = this.getUserCloe().email;
          this.findInput(this.bookingLists[0].tickets[0].form.inputsTicket, 'Email').isValid = true;
        }

        if (this.findInput(this.bookingLists[0].tickets[0].form.inputsTicket, 'Prénom')) {
          this.findInput(this.bookingLists[0].tickets[0].form.inputsTicket, 'Prénom').value = this.getUserCloe().lastname;
          this.findInput(this.bookingLists[0].tickets[0].form.inputsTicket, 'Prénom').isValid = true;
        }

      }
    }
  }

  initDataWhenOpenTicketing() {

    if(this.event.has_open_ticketing) {
      for(let i=0;i<this.bookingLists.length;i++) {
        for(let j=0;j<this.bookingLists[i].tickets.length;j++){

          if (this.findInput(this.bookingLists[i].tickets[j].form.inputsTicket,'Nom')) {
            this.findInput(this.bookingLists[i].tickets[j].form.inputsTicket,'Nom').value = this.getUserCloe().firstname;
            this.findInput(this.bookingLists[0].tickets[0].form.inputsTicket, 'Nom').isValid = true;
          }

          if (this.findInput(this.bookingLists[i].tickets[j].form.inputsTicket,'Email')) {
            this.findInput(this.bookingLists[i].tickets[j].form.inputsTicket,'Email').value = this.getUserCloe().email;
            this.findInput(this.bookingLists[0].tickets[0].form.inputsTicket, 'Email').isValid = true;
          }

          if (this.findInput(this.bookingLists[i].tickets[j].form.inputsTicket,'Prénom')) {
            this.findInput(this.bookingLists[i].tickets[j].form.inputsTicket,'Prénom').value = this.getUserCloe().lastname;
            this.findInput(this.bookingLists[0].tickets[0].form.inputsTicket, 'Prénom').isValid = true;
          }
        }
      }
    }
  }


  showCheckBuyerData(ticket) {
      for(let i=0;i<this.order.Buyerinputs.length;i++) {
        if(!this.order.Buyerinputs[i].isValid )
          return false;
      }
    return true;
  }




  //find input by label and get value in input array
  getElementValue(inputs,string) {
      for(let i=0;i<inputs.length;i++) {
        if(inputs[i].label==string)
          return inputs[i].value;
      }
    return null;
  }


  //find input  in array array by label
  getElement(inputs,string) {
    for(let i=0;i<inputs.length;i++) {
      if(inputs[i].label==string)
        return inputs[i];
    }
    return null;
  }



  touchInputs(inputs) {
    for(let i=0;i<inputs.length;i++) {
      inputs[i].touched = true
    }
  }


  fillTicketInputs(){
    for (let i = 0; i < this.bookingLists.length; i++) {
      // form validations
      for (let j = 0; j < this.bookingLists[i].tickets.length; j++) {
         this.bookingLists[i].tickets[j].firstname =  this.authservice.getUser().firstname;
         this.bookingLists[i].tickets[j].email =  this.authservice.getUser().email;
         this.bookingLists[i].tickets[j].lastname = this.authservice.getUser().lastname;
         this.tickets.push(this.bookingLists[i].tickets[j])
      }
    }
  }


  //only if email confirmation inputs exist
  checkEmailConfirmation(arr) {
    if(this.getElementValue(arr, 'Email') &&  this.getElementValue(arr, 'Confirmer email')) {
      if(this.getElementValue(arr, 'Email') !=  this.getElementValue(arr, 'Confirmer email')) {
        this.getElement(arr, 'Email').isValid = false;
        this.getElement(arr, 'Confirmer email').isValid = false;
        alert('emails non conforme');
        return;
      }
      else {
        this.getElement(arr, 'Email').isValid = true;
        this.getElement(arr, 'Confirmer email').isValid = true;
      }
    }
  }

  getSessionExpiredTime() {
    return this.bookingservice.retrieve('sessionExpirationTime');
  }

  organiserName(){
    if(this.bookingservice.retrieve('organisation') && this.bookingservice.retrieve('organisation').name)
    return this.bookingservice.retrieve('organisation').name;
    else return 'l\'organisateur';
  }

  calculTotal (pricings,codepromos?) {
    return this.functionUtils.calculTotal(pricings,codepromos);
  }

  moveToInscriptionEnd() {
    this.router.navigate(['/inscriptionend']);
  }

  bookingTicketsGotOtherInputs(bookings) {
    for (let i = 0; i < bookings.length; i++) {
      for (let j = 0; j < bookings[i].tickets.length; j++) {
        if(bookings[i].tickets[j].form.inputsOrder.length > 3 || bookings[i].tickets[j].form.inputsTicket.length > 3) {
          return true
        }
      }
    }
  }

  preAccount() {
   // console.log(this.bookingLists)
   if(this.bookingGotMoreThanOneTicket(this.bookingLists) || this.bookingTicketsGotOtherInputs(this.bookingLists)) {
     // console.log('more than')
     this.fillBuyerinputs();
     this.initDataWhenOpenTicketing();
     this.initTicketsDatawhenNotOpenTicketing();
     this.showBukinInput = true;
    } else {
     // console.log('one');
     // console.log(this.bookingLists)
     this.continuer();
   }
  }


  continuer() {
    if(this.getSessionExpiredTime() <= 0) {
      if(confirm('Votre session a expiré, Vous allez etre rediriger sur la page de l\'évènement')) {
        window.location.href = this.currenteventUrl;
        return;
      }
    }
    if(this.getUserCloe().isPreAccount) {
      this.condition = true;
      this.fillBuyerinputs();
      this.initDataWhenOpenTicketing();
      this.initTicketsDatawhenNotOpenTicketing();
    }
    if(this.bookingservice.retrieve('inscriptionIframe')) {
      //si c'est une inscriptions
      this.touchInputs(this.order.Buyerinputs);
      this.checkEmailConfirmation(this.order.Buyerinputs);
      this.fillTicketInputs();
      for (let k = 0; k < this.order.Buyerinputs.length; k++) {
        if (!this.order.Buyerinputs[k].isValid ) {
          alert(this.front_booking_infos.plese_fill_in_all_the_fields_corresponding_to_the_tickets);
          return;
        }
      }
      this.order.tickets = this.tickets;
      this.order.total_price =  parseFloat(this.order.total_price) + this.functionUtils.calculFrais(this.pricings,this.devise);
      this.order.ca = this.calculTotal(this.pricings,this.codePromosActivated);
      this.order.cAkces =  this.functionUtils.calculFrais(this.pricings,this.devise);
      this.order.nbParticipant = this.nbreTicket;
      this.bookingservice.saveOrder(this.order)
        .then(res => {
          this.moveToInscriptionEnd();
          return;
        })
        .catch(error => {
        });
      } else {
      if(!this.organiserCondition && (this.event.general_conditions_link || this.event.general_conditions_text)){
        alert('Vous devez accepter les conditions générales de l\'organisateur');
        return;
      } else if (this.billet  && !this.condition && !this.embeded) {
        alert(this.front_booking_infos.you_must_accept_term_and_condition);
        return;
      } else {
        //start validation here
        this.touchInputs(this.order.Buyerinputs);
        for (let i = 0; i < this.bookingLists.length; i++) {
          // form validations
          for (let j = 0; j < this.bookingLists[i].tickets.length; j++) {
            this.touchInputs(this.bookingLists[i].tickets[j].form.inputsTicket);
          }
        }
        //check mail confirmation
        for (let i = 0; i < this.bookingLists.length; i++) {
          for (let j = 0; j < this.bookingLists[i].tickets.length; j++) {
            this.checkEmailConfirmation(this.bookingLists[i].tickets[j].form.inputsTicket);
          }
        }
        this.checkEmailConfirmation(this.order.Buyerinputs);

        for (let i = 0; i < this.bookingLists.length; i++) {
          // four validations
          for (let j = 0; j < this.bookingLists[i].tickets.length; j++) {
            this.touchInputs(this.bookingLists[i].tickets[j].form.inputsTicket);
          }
          this.touchInputs(this.order.Buyerinputs);

          for (let j = 0; j < this.bookingLists[i].tickets.length; j++) {
            for (let k = 0; k < this.bookingLists[i].tickets[j].form.inputsTicket.length; k++) {
              if(!this.event.has_open_ticketing) {
              if (!this.bookingLists[i].tickets[j].form.inputsTicket[k].isValid ) {
                alert(this.front_booking_infos.plese_fill_in_all_the_fields_corresponding_to_the_tickets);
                return;
                }
              }
            }

            for (let k = 0; k < this.order.Buyerinputs.length; k++) {
              if (!this.order.Buyerinputs[k].isValid ) {
                alert(this.front_booking_infos.plese_fill_in_all_the_fields_corresponding_to_the_tickets);
                return;
              }
            }

            if(this.getElementValue(this.bookingLists[i].tickets[j].form.inputsTicket, 'Email') && this.sendToFriends)
              this.bookingLists[i].tickets[j].email = this.getElementValue(this.bookingLists[i].tickets[j].form.inputsTicket, 'Email');
            else
              this.bookingLists[i].tickets[j].email = this.getElementValue(this.order.Buyerinputs,'Email');

            this.bookingLists[i].tickets[j].firstname = this.getElementValue(this.bookingLists[i].tickets[j].form.inputsTicket, 'Nom');
            this.bookingLists[i].tickets[j].lastname = this.getElementValue(this.bookingLists[i].tickets[j].form.inputsTicket, 'Prénom');
            this.bookingLists[i].tickets[j]['options'] = this.getTicketAllOptions(this.bookingLists[i].tickets[j]);
            //this.addOrderOptions(this.bookingLists[i].tickets[j]);
            this.tickets.push(this.bookingLists[i].tickets[j])
          }
        }
      }

      this.order.tickets = this.tickets;
      this.order.id = null;
      this.bookingservice.store('order',this.order);
      this.bookingservice.store('tickets',this.tickets);
      this.bookingservice.store('pricings',this.pricings);
      this.bookingservice.store('bookingList',this.bookingLists);
      this.bookingservice.store('result',this.order);


      // let token=this.authservice.getToken()
      /* if(!this.authservice.loggedIn()) {
          this.authservice.setDestination('/booking/payment');
          this.router.navigate(['login/signin']);
          return;
        }*/

      if(!this.event.hasHousing)
         this.router.navigate(['/booking/payment']);
      else
        this.router.navigate(['/booking/housing']);
      return;
      }
    }
    addOrderOptions(ticket) {
      for(let i = 0 ; i < this.order.options.length; i++) {
        ticket.options.push(this.order.options[i])
      }
    }
    getTicketAllOptions(ticket) {
    let options = [];
      for(let i = 0;i < ticket.form.inputsTicket.length; i++) {
        if(ticket.form.inputsTicket[i].options) {
          for(let j = 0; j < ticket.form.inputsTicket[i].options.length; j++) {
            options.push(ticket.form.inputsTicket[i].options[j]);
          }
        }
      }
       for(let i=0;i<this.order.options.length;i++) {
        options.push(this.order.options[i])
      }
      return options;
    }
    back() {
      window.history.back();
    }

    navigateTo(url) {
      if(url === 'back') {
        window.history.back();
      } else  {
        this.router.navigate([url])
      }
    }
  }

